import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { JobMatchActionsModalComponent } from './job-match-actions-modal.component';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { AiAssistantModule } from 'src/app/shared/ai-assistant/ai-assistant.module';
import { EntityActivitiesModule } from 'src/app/shared/entity-activities/entity-activities.module';
import { ViewAssessmentReportModule } from 'src/app/shared/job-match-actions/view-assessment-report/view-assessment-report.module';
import { AssessmentInfoModule } from 'src/app/shared/job-match-actions/assessment-info/assessment-info.module';
import { JobMatchMeetingsModule } from 'src/app/shared/job-match-meetings/job-match-meetings.module';
import { SetJobMatchStatusModule } from 'src/app/shared/job-match-actions/set-job-match-status/set-job-match-status.module';
import { FeedbackExecutionModule } from 'src/app/shared/feedback-execution/feedback-execution.module';
import { JobMatchProfileOnConferenceModule } from 'src/app/pages/conference-page/conference/job-match-profile-on-conference/job-match-profile-on-conference.module';
import { SendCandidateOutreachEmailModule } from 'src/app/shared/send-candidate-outreach-email/send-candidate-outreach-email.module';
import { NotesAndCommunicationModule } from 'src/app/shared/candidate-actions/notes-and-communication/notes-and-communication.module';
import { UserCommunicationModule } from 'src/app/shared/user-communication/user-communication.module';
import { AssignRecruiterModule } from 'src/app/shared/job-match-actions/assign-recruiter/assign-recruiter.module';
import { MoveJobMatchStepModule } from 'src/app/shared/job-match-actions/move-job-match-step/move-job-match-step.module';
import { SendAssessmentModule } from 'src/app/shared/job-match-actions/send-assessment/send-assessment.module';
import { CancelAssessmentModule } from 'src/app/shared/job-match-actions/cancel-assessment/cancel-assessment.module';
import { ScheduleJobMatchItemModule } from 'src/app/shared/job-match-actions/schedule-job-match-item/schedule-job-match-item.module';
import { CancelJobMatchMeetingModule } from 'src/app/shared/job-match-actions/cancel-job-match-meeting/cancel-job-match-meeting.module';
import { AddEditCandidateContactModule } from 'src/app/shared/add-edit-candidate-contact/add-edit-candidate-contact.module';
import { CandidateJobMatchProfileModule } from 'src/app/shared/candidate-job-match-profile/candidate-job-match-profile.module';
import { ExportCandidateDocumentsModule } from 'src/app/shared/job-match-actions/export-candidate-documents/export-candidate-documents.module';
import { EmailDocumentsModule } from 'src/app/pages/mission-control-page/candidateprofile-page/email-documents/email-documents.module';
import { EmailClientReviewModule } from 'src/app/shared/email-client-review/email-client-review.module';
import { AddCandidatesModule } from 'src/app/pages/mission-control-page/add-candidates-page/add-candidates/add-candidates.module';

@NgModule({
  declarations: [JobMatchActionsModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    AiAssistantModule,
    EntityActivitiesModule,
    ViewAssessmentReportModule,
    AssessmentInfoModule,
    JobMatchMeetingsModule,
    SetJobMatchStatusModule,
    FeedbackExecutionModule,
    JobMatchProfileOnConferenceModule,
    SendCandidateOutreachEmailModule,
    NotesAndCommunicationModule,
    UserCommunicationModule,
    AssignRecruiterModule,
    MoveJobMatchStepModule,
    SendAssessmentModule,
    CancelAssessmentModule,
    ScheduleJobMatchItemModule,
    CancelJobMatchMeetingModule,
    AddEditCandidateContactModule,
    CandidateJobMatchProfileModule,
    ExportCandidateDocumentsModule,
    EmailDocumentsModule,
    EmailClientReviewModule,
    AddCandidatesModule
  ],
  exports: [JobMatchActionsModalComponent],
  entryComponents: [JobMatchActionsModalComponent]
})
export class JobMatchActionsModalModule { }
